// extracted by mini-css-extract-plugin
module.exports = {"errorMessage":"Service_errorMessage__1vu6X","content":"Service_content__KHWO4"};